import React from 'react';
import GoldenRadarDashboard from './Dashboard';
function App() { return <GoldenRadarDashboard />; }
export default App;
